module.exports = __webpack_public_path__ + "assets/255fe7a826ff1900cb19697cc643533a.mp3";